<div class="buy-sessionbingo-body">
    <div>
        <div class="buy-packages-model">
            <div class="buy-packages-body">
                <div class="game-name-details">
                    <div class="packages-name">
                        <div class="name">{{ packageName }}</div>
                    </div>
                    <div class="game-count">
                        <span class="txt">No Of Games</span>
                        <span class="count">{{ totalGames }}</span>
                    </div>
                </div>
                <div class="rooms-container">
                    @for (games of package_room_details; track games.package_roomName; let row_no = $index) {
                        <div class="rooms-innercontainer">
                            <div class="room-name-section">
                                <div class="room-name-container">
                                    <div class="bingo-session-packages-ball-type">
                                        {{ games.package_bingoType }}
                                    </div>
                                    <div class="room-name">{{ games.package_roomName }}</div>
                                </div>
                                @if (!isInGameClient) {
                                    <bg-custombutton
                                        [customStyle]="styleObj"
                                        [variant]="'filled'"
                                        [kind]="'primary'"
                                        [size]="'small'"
                                        [customClass]="'btn buy-session-btn btn-primary'"
                                        [button_text]="content.PlayNow"
                                        (click)="gameLaunch(games)"
                                        >{{ content.PlayNow }}
                                    </bg-custombutton>
                                }
                            </div>
                            <div class="Table">
                                <div class="Heading">
                                    <div class="Cell">
                                        <div class="buynow-price-header">{{ content.Date }}</div>
                                    </div>
                                    <div class="Cell">
                                        <div class="buynow-price-header">{{ content.Price }}</div>
                                    </div>
                                    <div class="Cell">
                                        <div class="buynow-price-header">{{ content.Prize }}</div>
                                    </div>
                                    <div class="Cell feature-cell icons">
                                        <div class="buynow-price-header">{{ content.Feature }}</div>
                                    </div>
                                    <div class="Cell">
                                        <div class="buynow-price-header">{{ content.Tickets }}</div>
                                    </div>
                                    @if (games.isFabGrabRoom) {
                                        <div class="Cell">
                                            <div class="buynow-number-header"></div>
                                        </div>
                                    }
                                </div>
                                @for (game of games.game_Info; track game.round_id; let col_no = $index) {
                                    <div>
                                        <div class="Row">
                                            <div class="Cell">
                                                {{ game.formatedStartTime }}
                                            </div>
                                            <div class="Cell">
                                                <div>
                                                    {{ game.card_cost | vnCurrency }}
                                                </div>
                                            </div>
                                            <div class="Cell">
                                                {{ game.prize | vnCurrency }}
                                            </div>
                                            <div class="Cell feature-cell icons">
                                                @for (feature of game.features; track feature) {
                                                    <span>
                                                        @if (feature == 'linked_game') {
                                                            <span>
                                                                <i [ngClass]="prebuyIconslist.columns.linkedIcon"></i>
                                                            </span>
                                                        }
                                                        <bg-feature-icon [feature]="feature" [featureList]="game.features" />
                                                    </span>
                                                }
                                                @if (!game.features.length || game.features.length <= 0) {
                                                    <span>-</span>
                                                }
                                            </div>
                                            <div class="Cell">
                                                {{ game.tickets }}
                                            </div>
                                            <!-- @if (games.isFabGrabRoom) {
                                                <div class="Cell">
                                                    {{
                                                        game.game_context?.FomoBingo?.previous_fomo_numbers != null && this[col_no] == undefined
                                                            ? game.game_context?.FomoBingo?.previous_fomo_numbers?.length
                                                            : this[col_no]
                                                              ? this[col_no]
                                                              : 0
                                                    }}/
                                                    {{ content.FabGrabBallCount }}
                                                </div>
                                            } -->
                                        </div>
                                        <!-- <div class="Row" *ngIf="games.isFabGrabRoom">
                                            <bg-fabgrab-room
                                                [games]="package_game_details"
                                                [col_no]="col_no"
                                                [game]="game"
                                                [isSessionBingo]="false"
                                                (ticketsSelectedCount)="updateCount($event)"
                                                [row_no]="row_no"
                                                [SelectedRoomId]="game.room_id"
                                                [isPurchased]="isPurchased">
                                            </bg-fabgrab-room>
                                        </div> -->
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
